import React, { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import DocumentDetails from "./DocumentTab/DocumentDetail/DocumentDetails";
import DocumentVersion from "./DocumentTab/DocumentVerison/DocumentVersion";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MeasurmentSheet from "./DocumentTab/MeasurmentSheet/MeasurmentSheet";
import DocumentReport from "./DocumentTab/DocumentReport/Report"

function DocumentDetailsPage() {
  const { id } = useParams();
  const [activeKey, setActiveKey] = useState("document");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const stateActiveKey = location.state?.activekey || "document";
    setActiveKey(stateActiveKey);
  }, [location.state]);

  const handleSelect = (key) => {
    setActiveKey(key); 
    navigate(`/document/${id}`, { state: { activekey: key } });
  };

  return (
    <div className="container-fluid">
      <div className="card p-0">
        <Tab.Container activeKey={activeKey} onSelect={handleSelect}>
          <div className="card-header p-0">
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="document" className="tabnav p-3">
                  <strong>Document</strong>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="version" className="tabnav p-3">
                  <strong>Versions</strong>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="te-sheet" className="tabnav p-3">
                  <strong>TE Sheet</strong>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="te-report" className="tabnav p-3">
                  <strong>TE Report</strong>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="card-body p-0">
            <Tab.Content>
              <Tab.Pane eventKey="document">
                {activeKey === "document" && <DocumentDetails />}
              </Tab.Pane>
              <Tab.Pane eventKey="version">
                {activeKey === "version" && <DocumentVersion />}
              </Tab.Pane>
              <Tab.Pane eventKey="te-sheet">
                {activeKey === "te-sheet" && <MeasurmentSheet />}
              </Tab.Pane>
              <Tab.Pane eventKey="te-report">
                {activeKey === "te-report" && <DocumentReport /> }
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
}

export default DocumentDetailsPage;